import PositionInfo from './PositionInfo';
export default PositionInfo